<template>
    <div class="conversion-box">
        <div class="conversion">
            <div class="form-box" v-loading="loading">
                <el-form>
                    <el-form-item label="产品">
                        <ListCheck :list="list" v-model="product" @change="handleProductChange"/>
                    </el-form-item>
                </el-form>
                <div class="p10" style="border: 1px solid #DCDFE6;border-radius: 4px;">
                    <FormGroup ref="formGroup" :product="product" :rootFormData="rootFormData" v-model="productFormData"
                        :rules="rules" @updateFetch="updateFetch" :venus_list="venus_list"
                        :industry_list="industry_list" :title_max_length="title_max_length" :corporate_max_length="corporate_max_length"/>
                </div>
            </div>
            <div class="footer">
                <el-button @click="handleCloseClick">取消</el-button>
                <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit"
                    :loading="saveLoaing">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import ListCheck from '@/views/marketingManagement/configuration/components/wkListCheck.vue';
import FormGroup from './formGroup.vue';
import _ from 'lodash';
import AsyncValidator from 'async-validator';
import {
    getMaterialInfoApi,
    BatchIndustryInfoApi,
    BatchPromotionVenusApi
} from '@/api/marketManage/configuration.js'
import { tipModal } from '@/views/marketingManagement/configuration/modal/index.js'
import { unHttp } from './unHttp.js'
let devalidator = (rule, value, callback) => {
    // 检查value是否以unHttp中的任意一个item开头
    let isFlag = unHttp.some(item => value?.startsWith(item));
    if (value && !isFlag) {
        callback(new Error("监测链接地址前缀错误"));
    } else {
        callback();
    }
}
let base_form = {
    logo: '',
    title_name: '',                      //标题
    ad_button_text: '',             //按钮文案
    // install_pkg_type: '0',          //是否预装 0 非预装 1 预装
    // match_type: '0',          //匹配方式 0 精准匹配 1 宽泛匹配
    pkg_src: '',                //应用包类型
    industry_l: '',                //创意行业
    corporate: '',                    //品牌名称 
    landing_page_type: '0',            //落地页链接类型，1：自定义落地页，2：维纳斯落地页
    landing_page_1: '',              //落地页链接
    landing_page_2: '',              //落地页链接类型，1：自定义落地页，2：维纳斯落地页
    monitor_docking_mode: '1',          //监测对接方式 0 客户端对接C2S(建议) 1 服务端对接S2S
    impression_url: '',  //曝光监测链接
    click_url: '',  //点击监测链接
    itg_sct_id: '',       //渠道包数量
    package_name: '',       //产品包名  2 是应用直达 使用
    deep_link_url: '',       //deeplink链接 2 是应用直达 使用
    h5_url: '',       //H5链接 2 是应用直达 使用
}
let base_rules = {
    logo: [
        { required: true, type: 'string', message: '请上传品牌logo', trigger: 'blur' },
    ],
    title_name: [
        { required: true, type: 'string', message: '请输入标题', trigger: 'blur' },
    ],
    corporate: [
        { required: true, type: 'string', message: '请输入品牌名称', trigger: 'blur' },
    ],
    industry_l: [   
        { required: true, type: 'array', message: '请选择创意行业', trigger: 'change', },
    ],
    impression_url: [
        // { validator: devalidator, trigger: 'change' },
        { pattern: /^https:\/\/.{1,2048}$/, message: '请输入以https://开头的URL地址，长度不超过2048个字符', trigger: 'blur' }
    ],
    click_url: [
        { pattern: /^https:\/\/.{1,2048}$/, message: '请输入以https://开头的URL地址，长度不超过2048个字符', trigger: 'blur' }
    ]
}
// promotion_purpose  推广方式 0 应用下载 2 是应用直达  应用直达时 包含 package_name  deep_link_url  h5_url
export default {
    name: 'WkProductConfig',
    components: {
        ListCheck,
        FormGroup
    },
    props: ['rootFormData', 'rootFormDataOptions', 'cbs', 'value'],
    data() {
        return {
            once: false,
            list: [],
            product: '',
            saveLoaing: false,
            loading: false,
            field: 'name',
            form: {
            },
            productFormData: {...base_form},
            rules: {},
            errors_rules: {
                industry_l: '创意行业',
                landing_page_1: '自定义落地页',
                landing_page_2: '落地页',
            },
            venus_list: [],
            industry_list: [],
            title_max_length: 100,
            corporate_max_length: 100
        }
    },
    watch: {
        'product': {
            async handler(newVal, oldVal) {
                if (!newVal) return
                this.loading = true;
                this.productFormData = this.form[newVal] || {...base_form};
                this.$nextTick(() => {
                    this.$refs.formGroup.resetForm();
                })
                this.loading = false;
            },
        },
        'productFormData': {
            handler(newVal, oldVal) {
                // if (_.isEmpty(newVal, oldVal)) return
                if (this.product) {
                    delete this.rules['landing_page_2']
                    if (newVal['landing_page_type'] == '1') {
                        this.$set(this.rules, 'landing_page_2', [
                            { required: true, message: '请选择落地页', trigger: 'change' },
                        ])
                    }
                    this.$set(this.form, this.product, newVal)
                    this.$nextTick(() => {
                        if (!this.once) {
                            this.$refs.formGroup.resetForm()
                            this.once = true
                        }
                    })
                }
            },
            deep: true
        }
    },
    mounted() {
        this.getInfo().then(() => {
            const { app_id } = this.rootFormDataOptions;
            this.list = app_id
            let first_item = _.head(app_id);
            let keys = this.value && this.value.map(v => String(v.app_id));
            if (!_.isEmpty(this.value)) {
                let new_value = this.convertArrayToObject(this.value)
                this.list.forEach(item => {
                    console.log('keys:', keys.includes(item.value), keys, item.value);
                    if (keys.includes(item.value)) {
                        let new_item = { ...new_value[item.value] }
                        if (new_value[item.value].landing_page_type == '0') {
                            new_item.landing_page_1 = new_value[item.value].landing_page_id;
                        } else if (new_value[item.value].landing_page_type == '1') {
                            new_item.landing_page_2 = new_value[item.value].landing_page_id;
                        }
                        delete new_item.landing_page_id;
                        this.$set(this.form, item.value, new_item)
                    }
                })
                this.product = first_item?.value;
            } else {
                this.product = first_item?.value;
                 const productInfo = _.keyBy(this.productInfo, 'product_id');
                this.$set(this.form, this.product, { ...this.productFormData, deep_link_url: productInfo[this.product]?.deep_link_url || '' })
            }
            let res_rules = this.rootFormData.promotion_purpose == '0'
                ? {
                    ...base_rules,
                    pkg_src: [
                        { required: true, message: '请选择应用包类型', trigger: 'change', },
                    ],
                }
                : {
                    ...base_rules
                };
            this.$set(this, 'rules', res_rules)
        })
    },
    methods: {
        handleProductChange: _.debounce((newVal) => {
            console.log('newVal:', newVal)
        }, 1000),
        updateFetch(type) {
            if (type === 'venus_list') {
                BatchPromotionVenusApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 11,
                    search: ''
                }).then(res => {
                    this.venus_list = res.data.list;
                })
            }
        },
        handleCloseClick() {
            this.$emit('close')
        },
        // validateAll() {
        //     const descriptor = {};
        //     const current_keys = Object.keys(this.productFormData);
        //     current_keys.forEach(key => {
        //         descriptor[key] = this.rules[key];
        //     })
        //     const validator = new AsyncValidator(this.descriptor);
        // },
        getInfo() {
            this.loading = true;
            return Promise.all([
                getMaterialInfoApi({
                    display_type: this.rootFormData.ad_placement_id?.join(','),
                    plat_id: 11,
                    type: 'text'
                }),
                BatchIndustryInfoApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 11,
                }),
                BatchPromotionVenusApi({
                    account_id: this.rootFormData.account_id,
                    plat_id: 11,
                    search: ''
                })
            ]).then(([material_res,indestry_res, venus_res]) => {
                console.log('API 请求成功:',material_res, indestry_res, venus_res);
                if (indestry_res.code == 200 && venus_res.code == 200) {

                    let min_ids = material_res.data.reduce((acc, item) => {
                        if(item?.ele_type == 4) {
                            acc['title'].push(item?.text_length)   
                        }else if(item?.ele_type == 5){
                            acc['corporate'].push(item?.text_length)   
                        }
                        return acc
                    }, {title: [], corporate: []})
                    // lodash 去重 取最小值

                    let title_max_length = _.minBy(min_ids['title'], function(o) {return Number(o)})
                    let corporate_max_length = _.minBy(min_ids['corporate'], function(o) {return Number(o)})
                    this.title_max_length = title_max_length
                    this.corporate_max_length = corporate_max_length

                    this.industry_list = indestry_res.data.list;
                    this.venus_list = venus_res.data.list;
                    return Promise.resolve();
                } else {
                    return Promise.reject(new Error('API 请求返回非 200 状态码'));
                }
            }).catch((error) => {
                return Promise.reject(error);
            }).finally(() => {
                this.loading = false;
            })
        },
        convertAppData(data) {
            return Object.entries(data).map(([app_id, appInfo]) => {
                let ret_appInfo = Object.entries(appInfo).reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});
                return {
                    app_id,
                    ...ret_appInfo
                }
            });
        },
        convertArrayToObject(array) {
            return array.reduce((acc, item) => {
                const { app_id, ...rest } = item;
                acc[app_id] = rest;
                return acc;
            }, {});
        },
        onSubmit: async function () {
            this.$refs.formGroup.submitForm()
            // const validator = new AsyncValidator(this.rules);
            const newForm = _.cloneDeep(this.form);
            console.log('newForm:', newForm, this.list);
            let promiseList = [];
            _.forEach(newForm, (item, key) => {
                let descriptor = {};
                let landing_page_1 = []
                let landing_page_2 = []
                let res_rules = this.rootFormData.promotion_purpose == '0'
                ? {
                    ...base_rules,
                    pkg_src: [
                        { required: true, message: '请选择应用包类型', trigger: 'change', },
                    ],
                }
                : {
                    ...base_rules
                };
                if (item['landing_page_type'] == '1') {
                    landing_page_2 = [
                        { required: true, message: '请选择落地页', trigger: 'change' },
                    ]
                    descriptor = { ...res_rules, ...{ landing_page_2: landing_page_2 } };
                }else{
                    descriptor = { ...res_rules };
                }

                console.log('descriptor:', descriptor);
                const validator = new AsyncValidator(descriptor);

                promiseList.push(new Promise((resolve, reject) => {
                    validator.validate(item, (errors, fields) => {
                        if (errors) {
                            // console.log('验证失败-errors:', errors, fields);
                            let error_names = Object.keys(this.errors_rules);
                            let reset_errors = errors.map((item) => {
                                let new_item = { ...item };
                                if (error_names.includes(item.field)) {
                                    new_item.label = this.errors_rules[item.field];
                                }
                                return new_item;
                            })
                            let label_list = _.filter(this.list, (v) => { return v.value == key })
                            let res_errors = {
                                label: _.head(label_list).label,
                                value: key,
                                errors: reset_errors
                            }
                            reject(res_errors);
                        } else {
                            resolve();
                        }
                    })
                }))
            })

            try {
                this.saveLoaing = true;
                const results = await Promise.allSettled(promiseList);
                const invalidResults = results.filter(result => result.status === 'rejected');

                let newFormKeys = Object.keys(newForm)
                let emptyForm = this.list.filter(v => !newFormKeys.includes(v.value)).map(v => v.app_name)
                console.log('emptyForm:', emptyForm, invalidResults);
                if (invalidResults.length > 0 || emptyForm.length > 0) {
                    const allErrors = invalidResults.flatMap(result => result.reason);
                    let tipErrors = allErrors.map(v => v.label)
                    let errorObjMsg = {
                        '': _.uniq([...tipErrors, ...emptyForm])
                    };
                    tipModal({
                        props: {
                            tip: '存在未通过校验的产品，请检查，具体如下：',
                            list: errorObjMsg
                        },
                    })
                } else {
                    console.log('所有表单验证通过');
                    // 在这里执行表单提交逻辑 对this.form 进行操作，根据 landing_page_type 进行不同的处理 1 把 landing_page_1 赋值给 landing_page_id, 2 把 landing_page_2 赋值给 landing_page_id,并且过滤掉landing_page_1与landing_page_2
                    _.forEach(newForm, (item) => {
                        if (item.landing_page_type == '0') {
                            item.landing_page_id = item.landing_page_1;
                        } else if (item.landing_page_type == '1') {
                            item.landing_page_id = item.landing_page_2;
                        }
                        // 过滤掉 landing_page_1 和 landing_page_2
                        delete item.landing_page_1;
                        delete item.landing_page_2;
                    });
                    // 可以在这里使用新数据进行提交操作
                    console.log('处理后的新数据:', newForm);
                    let newFormData = this.convertAppData(newForm)
                    console.log('处理后的新数据1:', newFormData);
                    this.cbs.onSubmit(newFormData)
                }
            } catch (error) {
                console.log('执行验证时出错:', error);
            } finally {
                this.saveLoaing = false;
            }

        }
    }
}
</script>
<style lang="scss" scoped>
.tip-icon {
    font-size: 18px;
    margin-right: 4px;
}

.conversion-box {
    height: 100%;
    width: 100%;
    overflow-x: auto;
}

.conversion {
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 1200px;

    .tip {
        margin-bottom: 10px;
    }

    .form-box {
        height: 0;
        flex: 1;
        overflow: auto;
        // background: red;
        margin-top: 16px;
    }

    .footer {
        height: 60px;
        line-height: 60px;
        text-align: right;
        padding-right: 80px;
        margin: 0 -20px;
        box-shadow: 4px 0 4px #ccc;
    }
}
</style>